import React, { useState } from "react";
import { Card, Form, Row, Col, Modal, Select, Upload, Button, message, List, Collapse, Divider, Typography } from "antd";
import { documentCategoryCodes, requiredMessages } from "../../utils/constants";
import { UploadOutlined } from "@ant-design/icons";
import { ModalFooterButtons } from "../../shared/components/modalFooterButtons/modalFooterButtons";
import { useCurrentUserContext } from "../../context/currentUserContext";

const { Panel } = Collapse;
const { Text } = Typography;

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const CreateDocumentFlux = ({showDocumentFluxModal, handelModalClose, loadingButton, operators, fluxErrors, handelCreateFlux, }) => {

  const [fieldsChanged, setFieldsChanged] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileList, setFileList] = useState([]);
  const { currentUser } = useCurrentUserContext();
  
  const beforeUpload = (file) => {
    let fileExt = file.name.split(".");
    const isZip = file.type === 'application/x-zip-compressed' || fileExt.toLowerCase() === "zip";
    if (!isZip) {
        message.error('You can only upload Zip file!');
    }
    this.state.uploadedFile = file;
    return isZip;
  }

  const onRemove = () => {
    setUploadedFile(null);
    setFileList([]);
  };

  const handleChange = (info) => {
    if (info.file.status === "removed") {
      setUploadedFile(null);
      setFileList([]);
    } else {
      setUploadedFile(info.file);
      setFileList([...info.fileList]);
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  const handleUpload = (values) => {
    handelCreateFlux(values);
  };

  const genExtra = () => {
    return <Text>Detaggli</Text>;
  };

  return (
    <>
      <Modal
        width={800}
        title="Carica flusso"
        open={showDocumentFluxModal}
        destroyOnClose={true}
        onCancel={handelModalClose}
        footer={[
          <ModalFooterButtons
            key="createFlux"
            disabled={!uploadedFile}
            loadingButton={loadingButton}
            modalClose={handelModalClose}
            formId={"createFlux"}
          />,
        ]}
      >
        <Card>
          <Form
            id="createFlux"
            layout="vertical"
            {...formItemLayout}
            onFinish={handleUpload}
            onValuesChange={() => setFieldsChanged(true)}
          >
            {fluxErrors && fluxErrors.length > 0 && (
              <>
                <Row gutter={{ lg: 24 }} className="mb15">
                  <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                    <Collapse
                      defaultActiveKey={["1"]}
                      expandIconPosition="end"
                      style={{ background: "#ffe9e9" }}
                    >
                      <Panel
                        header="Si sono verificati alcuni errori durante il caricamento del file"
                        key="1"
                        extra={genExtra()}
                      >
                        {fluxErrors && (
                          <List
                            itemLayout="horizontal"
                            size="small"
                            dataSource={fluxErrors}
                            renderItem={(item) => (
                              <List.Item>
                                <List.Item.Meta
                                  title={`Errore:  ${item.errorMessage}`}
                                  description={`Numero Doc:  ${item.documentNumber}`}
                                />
                              </List.Item>
                            )}
                          />
                        )}
                      </Panel>
                    </Collapse>
                  </Col>
                </Row>
                <Divider />
              </>
            )}

            <Row gutter={{ lg: 24 }} className="row-margin">
              <Col  className="gutter-row"  xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} >
                <Form.Item
                  label="Flusso"
                  name="file"
                  rules={[
                    { required: true, message: requiredMessages.requiredField },
                  ]}
                >
                  <Upload
                    accept=".zip"
                    maxCount={1}
                    listType="picture"
                    onChange={handleChange}
                    onRemove={onRemove}
                    beforeUpload={beforeUpload}
                  >
                    <Button icon={<UploadOutlined />}>Seleziona file</Button>
                  </Upload>
                </Form.Item>
              </Col>

              {currentUser.lastSelectedCategoryCode != documentCategoryCodes.distinte && (

              <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} >
                <Form.Item
                  label="Operatore"
                  name="operatorId"
                  hasFeedback
                >
                  <Select
                    showSearch
                    loading={!operators}
                    placeholder="Seleziona"
                    optionFilterProp="label"
                    options={operators}
                  >                    
                  </Select>
                </Form.Item>
              </Col>
              )}
              
            </Row>
          </Form>
        </Card>
      </Modal>
    </>
  );
};

export default CreateDocumentFlux;
